<template>
  <div class="consult-binding-mobile" v-show="value">
    <div>
      <div class="mask" @click="close"></div>
      <div class="consult-binding-mobile-wrap" @touchmove.prevent>
        <div class="phone-content">
          <p class="title">{{ title }}</p>
          <div class="label">
            <input
              :class="{
                input: true,
                'input-phone': true
              }"
              type="tel"
              v-model.number="FormPhoneNumber"
              maxlength="11"
              placeholder="请输入您的手机号码"
              ref="FormPhoneInput"
            />
          </div>
          <div class="label">
            <input
              :class="{
                input: true,
                'input-code': true
              }"
              type="tel"
              v-model.number="FormVerifyCode"
              maxlength="6"
              placeholder="请输入验证码"
              ref="FormCodeInput"
            />
            <div
              tag="a"
              :class="[
                'verify-btn',
                verifyCodeDisabled
                  ? 'verify-disable'
                  : themeClass.color + ' ' + themeClass.borderColor
              ]"
              @click="FormGetCode"
              v-html="
                verifyCodeDisabled
                  ? '重新发送(' + verifyCodeTime + ')'
                  : '获取验证码'
              "
            ></div>
          </div>
          <div :id="ncId" class="ali-nc"></div>
          <div class="rules-container">
            <div class="rules" v-if="rules.length" @click="agree = !agree">
              <div
                :class="{
                  icon: true,
                  'active icon-node-website icon-gou': agree
                }"
              ></div>
              同意
              <span
                class="rule"
                v-for="(v, i) in rules"
                :key="i"
                @click.stop="v.onClick"
                >《{{ v.rule }}》{{ i === rules.length - 1 ? '' : '与' }}</span
              >
            </div>
          </div>
          <div :class="['redbag-form-btn', themeClass.bg]" @click="FormSubmit">
            {{ submitText }}
          </div>
        </div>
        <div
          tag="a"
          :class="['model-close-btn']"
          @click="$emit('changePhoneModal')"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { consultAliVerify } from 'lib/tools/aliVerify.js'
import { checkValidateAliyun, mobileLogin } from 'api/index.js'
import { getCookie } from 'lib/tools/cookies.js'

const verifyCodeMixin = {
  data() {
    return {
      verifyCodeTime: 0
    }
  },
  computed: {
    verifyCodeDisabled() {
      return this.verifyCodeTime !== 0
    }
  },

  methods: {
    verifyCodeStart() {
      if (this.verifyCodeTimer) {
        return
      }
      let count = 60
      this.verifyCodeTime = count
      this.verifyCodeTimer = setInterval(() => {
        count--
        if (count < 0) {
          clearInterval(this.verifyCodeTimer)
          this.verifyCodeTimer = null
        } else {
          this.verifyCodeTime = count
        }
      }, 1000)
    }
  }
}
import inject from 'lib/component/vue/theme/inject.js'

export default {
  mixins: [inject, verifyCodeMixin],
  props: {
    submitText: {
      type: String,
      default: '确认提交'
    },
    title: {
      type: String,
      default: '验证手机号'
    },
    value: {
      type: Boolean,
      default: false
    },
    flag: {
      type: String,
      default() {
        const { channel_flag } = this.$route.query
        if (this.$isServer) {
          return channel_flag || ''
        }
        return channel_flag || getCookie('zixun_channel_flag') || ''
      }
    },
    login: {
      type: Function,
      default(phone, validCode) {
        let loading = this.$loading('登陆中...')
        return new Promise((resolve, reject) => {
          mobileLogin({
            phone,
            validCode,
            registerMark: this.flag
          })
            .then(res => {
              loading.close()
              if (res.code === 0) {
                return resolve(res)
              }
              this.$toast(res.message || '登陆失败')
              return reject(res)
            })
            .catch(e => {
              console.log(e)
              loading.close()
              reject(e)
            })
        })
      }
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
    maskClose: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      editorShow: false,
      FormPhoneNumber: '',
      FormVerifyCode: '',
      isSendVerify: false,
      toastTxt: '',
      isShowToast: false,
      agree: true,
      ncId: 'nc_' + +new Date()
    }
  },

  methods: {
    phoneAvailable(str, isOversea = false) {
      if (isOversea) {
        return typeof str === 'number'
      } else {
        return /^[1][0-9][0-9]{9}$/.test(str)
      }
    },
    _showToast(message) {
      this.$toast(message)
    },
    FormGetCode() {
      if (this.isSendVerify || this.verifyCodeDisabled) return
      if (!this.phoneAvailable(this.FormPhoneNumber)) {
        this._showToast('请输入正确的手机号码')
        return
      }
      this.isSendVerify = true
      consultAliVerify({
        renderTo: `#${this.ncId}`
      })
        .then(data =>
          checkValidateAliyun(
            qs.stringify({
              account: this.FormPhoneNumber,
              nc_sessionid: data.csessionid,
              nc_token: data.nc_token,
              nc_sig: data.sig,
              nc_scene: data.nc_sence,
              appkey: data.nc_appKey,
              is_oversea: +this.isOversea || 0
            })
          )
        )
        .then(res => {
          if (+res.code === 0) {
            this.verifyCodeStart()
            this.isSendVerify = false
            this._showToast('验证码已发送')
          } else if (res.code === 'send_validcode_invalid') {
            this.verifyCodeStart()
            this.isSendVerify = false
            this._showToast('请等待一分钟后再试')
          } else {
            this._showToast('验证码发送失败')
          }
        })
    },

    FormSubmit() {
      if (this.rules.length && !this.agree) {
        this._showToast(
          `请同意${this.rules.reduce(
            (all, v) => all + '《' + v.rule + '》',
            ''
          )}`
        )
        return
      }
      if (!this.phoneAvailable(this.FormPhoneNumber)) {
        this._showToast('请输入正确的手机号码')
        return
      }
      if (!this.FormVerifyCode) {
        this._showToast('请输入验证码')
        return
      }
      if (this.FormVerifyCode && this.FormVerifyCode.toString().length < 6) {
        this._showToast('请输入正确的验证码')
        return
      }

      this.login(this.FormPhoneNumber, this.FormVerifyCode).then(res => {
        this.$emit('success', res)
        this.$emit('input', false)
        this.FormPhoneNumber = ''
        this.FormVerifyCode = ''
      })
    },

    close() {
      if (this.maskClose) {
        this.$emit('input', false)
      }
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
$themeColor: #6982fa;
.consult-binding-mobile {
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    top: 0;
    left: 0;
    z-index: 2;
  }
  &-wrap {
    position: fixed;
    width: pxToRem(560);
    border-radius: pxToRem(30);
    box-sizing: border-box;
    background-color: #fff;
    left: 50%;
    // top: auto;
    // bottom: pxToRem(450);
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 0 pxToRem(30) pxToRem(40);
    z-index: 11;
  }
  .title {
    padding-bottom: 0;
    font-size: pxToRem(36);
    line-height: pxToRem(76);
    font-weight: bold;
    color: #21252d;
    padding-top: pxToRem(40);
    padding-bottom: pxToRem(10);
    text-align: center;
  }
  .label {
    padding: pxToRem(30) 0 0;
    display: flex;
  }
  .verify-btn,
  .input {
    width: 100%;
    font-size: pxToRem(24);
    line-height: pxToRem(42);
    padding: pxToRem(20) pxToRem(30);
    border-radius: pxToRem(10);
    -webkit-appearance: none;
  }
  .input {
    background: #f7f7f7;
    border-radius: pxToRem(28);
    font-size: pxToRem(26);

    &::-moz-placeholder,
    &:-moz-placeholder,
    &::-webkit-input-placeholder,
    &:-webkit-input-placeholder {
      color: #bcc2cf !important;
    }
  }
  .input-code {
    // width: pxToRem(340-36);
    margin-right: pxToRem(30);
  }

  .verify-btn {
    // margin-left: pxToRem(36);
    width: pxToRem(360);
    padding: 0 pxToRem(20);
    text-align: center;
    box-sizing: border-box;
    white-space: nowrap;
    text-decoration: none;
    border: 1px solid $themeColor;
    color: $themeColor;
    border-radius: pxToRem(80);
    line-height: 1.1;
    display: flex;
    justify-content: center;
    align-items: center;
    &.verify-disable {
      border: 1px solid #999;
      color: #999;
    }
  }
  .redbag-form-btn {
    background: $themeColor;
    font-size: pxToRem(26);
    color: #ffffff;
    flex: 1;
    text-align: center;
    line-height: pxToRem(80);
    border-radius: pxToRem(80);
    text-decoration: none;
  }

  .model-close-btn {
    position: absolute;
    display: block;
    right: 0;
    bottom: 100%;
    margin-bottom: pxToRem(20);
    // background: url('../../assets/images/qingsu/bg-model-close-btn.png');
    background-size: 100% 100%;
    width: pxToRem(64);
    height: pxToRem(64);
  }

  .rules-container {
    padding: pxToRem(15) 0;
    .rules {
      padding: pxToRem(15) 0;
      font-size: pxToRem(22);
      color: #6c798c;
      display: flex;
      align-items: center;
      line-height: pxToRem(40);
    }
    .rule {
      color: #718aff;
    }
    .icon {
      width: pxToRem(28);
      height: pxToRem(28);
      border-radius: pxToRem(8);
      display: flex;
      background: #e1ebf1;
      margin-right: pxToRem(20);
      justify-content: center;
      align-items: center;
      font-size: pxToRem(18);

      &.active {
        color: #fff;
        background: #718aff;
      }
    }
  }
}
</style>

<style lang="scss">
.ali-nc {
  $h: pxToRem(68);
  $c: #6982fa;
  $radius: pxToRem(14);

  .nc_wrapper,
  ._nc {
    margin: pxToRem(30) auto 0;
  }

  .slider,
  .nc_wrapper {
    width: 100% !important;
    border-radius: $radius;
    overflow: hidden;
    left: 0 !important;
    right: 0 !important;
  }
  .stage {
    padding: 0 !important;
  }
  .label, // mobile
    .scale_text {
    // opacity: 0 !important;
    &,
    * {
      font-size: pxToRem(24) !important;
      line-height: $h !important;
      height: $h !important;
      color: #6c798c !important;
    }
  }

  .btn_slide,
  .button {
    width: $h !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: $radius;
    .icon {
      width: auto;
      height: auto;
      font-size: pxToRem(40) !important;
      position: static !important;
    }
  }
  .nc-lang-cnt,
  .bg-green {
    font-size: pxToRem(24) !important;
    color: #6c798c !important;
  }

  .icon-slide-arrow {
    color: #9da3ac !important;
  }
  .icon-ok,
  .btn_ok {
    // color: $c !important;
    // color: #afd1f1 !important;
    // color: var(--theme-color) !important;
  }
  .bg-green,
  .nc_bg {
    // background: $c !important;
    // background: rgba(11, 139, 255, 0.8);
    color: #fff !important;
    // background: #afd1f1 !important;
    // background: var(--theme-color) !important;
  }

  .slider,
    .button,
    .stage,
    .bg-green,
    //pc
    .nc_iconfont,
    .btn_slide,
    .nc_scale {
    height: $h !important;
    line-height: $h !important;
    border: none !important;
  }

  .nc_scale,
  .slider {
    border: 1px solid #e7e7e7 !important;
  }

  .slider,
  .nc_wrapper {
    border-color: #eaeaea !important;
    box-shadow: none !important;
  }
}
</style>
